import React from 'react';

interface Props {
  className?: string;
}

const Solar: React.FC<Props> = ({ className = '' }: Props) => (
  <svg
    className={className}
    fill="none"
    height="14"
    viewBox="0 0 20 21"
    width="14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1108_25565)" id="Solar Panel">
      <path
        d="M3 0.5H2.19375L2.02187 1.48438L0.021875 13.0469L0 13.1797V13.3125V14.25V15.5H1H9V18H7H6V20.5H7H13H14V18H13H11V15.5H19H20V14.25V13.3125V13.1797L19.9781 13.0508L17.9781 1.48828L17.8062 0.5H17H3ZM3.10313 7.0625L3.80625 3H6.64687L6.32188 7.0625H3.10313ZM2.78125 8.9375H6.17188L5.84688 13H2.07812L2.78125 8.9375ZM7.68125 8.9375H12.3219L12.6469 13H7.35313L7.67812 8.9375H7.68125ZM13.8313 8.9375H17.2188L17.9219 13H14.1531L13.8281 8.9375H13.8313ZM16.8969 7.0625H13.6781L13.3531 3H16.1938L16.8969 7.0625ZM12.1719 7.0625H7.82812L8.15312 3H11.8469L12.1719 7.0625Z"
        fill="currentColor"
        id="Vector"
      />
    </g>
    <defs>
      <clipPath id="clip0_1108_25565">
        <rect
          fill="white"
          height="20"
          transform="translate(0 0.5)"
          width="20"
        />
      </clipPath>
    </defs>
  </svg>
);

export default Solar;
